/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type TrashedProjectsAdminType from '@jira/spa-apps__admin-pages-trashed-projects/src/TrashedProjectsAdminType.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyTrashedProjectsAdmin: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof TrashedProjectsAdminType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-trashed-projects", jiraSpaEntry: "async-trashed-projects" */ '@jira/spa-apps__admin-pages-trashed-projects/src/TrashedProjectsAdminType.tsx'
		),
	),
);

const AsyncTrashedProjectsAdmin = (): React.JSX.Element => (
	<LazyPage Page={LazyTrashedProjectsAdmin} pageId="trashed-projects" shouldShowSpinner />
);

export default AsyncTrashedProjectsAdmin;
